<template>
    <a class="suggested-country-btn font-fauli"
       :href="href"
       @click.prevent="$emit('click')">
        <span>
            <img v-if="flagUrl"
                 :src="flagUrl"
                 :alt="`${countryName} flag`"
                 class="object-contain mx-10 w-[48px] h-[28px]">
            {{ countryName }}
        </span>
        <img :src="arrowRightUrl"
             alt="arrow right"
             class="arrow-right-icon">
    </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import arrowRightUrl from '@/assets/images/arrow-right.svg';

export default defineComponent({
    name: 'CountrySuggestedButton',
    props: {
        countryName: {
            type: String,
            required: true,
        },
        flagUrl: {
            type: String,
            default: null,
        },
        href: {
            type: String,
            default: '#',
        },
    },
    emits: ['click'],
    setup() {
        return {
            arrowRightUrl,
        };
    },
});
</script>

<style scoped>
    .suggested-country-btn {
        background-image: url('@/assets/images/country-suggested-bg.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        min-height: 60px;
        padding: 1rem 1.5rem;
        font-weight: 400;
        width: 280px;
    }

    .arrow-right-icon {
        margin-left: auto;
        height: 13px;
        object-fit: contain;
        margin-right: 20px;
    }
</style>
